import {LocaleDictionaryRegistrationPage} from "../../interface/registrationPage";
import {PersonalAgreement} from "../ru/personalAgreement";

export const registrationPage: LocaleDictionaryRegistrationPage = {
    checkBoxCaption1: 'I give my ',
    checkBoxCaptionLink: 'consent to the processing of personal data and join the electronic interaction',
    checkBoxCaption2: 'and I am familiar',
    checkBoxCaptionLink2: 'with the privacy policy.',
    agreementTitle: 'Согласие на обработку персональных данных и соглашение об электронном взаимодействии',
    agreementTitle2: 'Политика конфиденциальности',
    agreementText: PersonalAgreement,
    policyLink: 'https://privacypolicy.rudn.ru/pdpap_policy.html',
    personalDataProcessingLink: 'https://privacypolicy.rudn.ru/privacy_policy.html',
}
